// @ vendors
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const gdprConsentsActions = require('actions/gdprConsents');
// @helpers
const { formatText } = require('core/i18n').i18n;
// @actions
const {
    hireContractFailure,
    hireContractSuccess,
} = require('actions/contracts');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const signaturePatternActions = require('actions/signaturePattern');
const { ACCOUNT_INTERVENTION_OWNER_CODE } = require('constants/index');
import { registerDocuments } from 'actions/registerDocuments';
import { DEPOSIT_PRODUCT_ALIAS } from 'constants/hiringProductInformation';

const depositNoNewMoneyHireInformationIsFetching = isAccountChange => ({
    type: actionTypes.CONTRACT_METHOD_NO_NEW_MONEY_DEPOSIT_GET_DATA_IS_FETCHING,
    payload: {
        isAccountChange
    }
});

const depositNoNewMoneyHireInformationSuccess = response => ({
    type: actionTypes.CONTRACT_METHOD_NO_NEW_MONEY_DEPOSIT_GET_DATA_SUCCESS,
    payload: {
        response
    }
});

const depositNoNewMoneyHireInformationFailure = errorBody => ({
    type: actionTypes.CONTRACT_METHOD_NO_NEW_MONEY_DEPOSIT_GET_DATA_FAILURE,
    payload: {
        errorBody
    }
});

const requestMainNoNewMoneyDepositHireInformation = (immAccount, interveners, isAccountChange = false) => (dispatch, getState) => {
    dispatch(depositNoNewMoneyHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return (intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE || intervener.get("typeNumber") === ACCOUNT_INTERVENTION_OWNER_CODE) &&
               (intervener.ordenIntervencion === 1 || intervener.get("interventionOrder") === "1");
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const contractWizard = getState().contracts;
    const productInfo = contractWizard.get('deposit_product');
    const requestData = {
        header: {
            version: 2
        },
        query: {
            moneda: currency,
            codigoDeEstandar: productInfo.get('standard'),
            rellamada: 'N',
            tipoac: 'B',
            producto: productInfo.get('type'),
            subProducto: productInfo.get('subtype'),
            titularTipoPersona: firstHolder.tipoPersona || firstHolder.getIn(["identification", "type"]),
            titularCodigoPersona: firstHolder.numeroPersona || firstHolder.getIn(["identification", "code"])
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositNoNewMoneyHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositNoNewMoneyHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};

const refreshMainNoNewMoneyDepositHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestMainNoNewMoneyDepositHireInformation(immAccount, interveners, true));
};

const refreshMainBonifiedNoNewMoneyDepositHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestMainNoNewMoneyDepositHireInformation(immAccount, interveners, true));
};

const refreshMainNoNewMoneyDepositHireInformationDepositDropdown = () => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const immContracts = getState().contracts;
    const cardDetails = immContracts.get('card_details');    
    const accountId = cardDetails.find(x => x.get('id') === 'cta_seleccionada').get('value');
    const immAccount = immAccounts.getIn(['byId', accountId]);
    const interveners = immContracts.get('interveners');
    immAccount && interveners.size && dispatch(requestMainNoNewMoneyDepositHireInformation(immAccount, interveners, true));
};

const refreshMainBalanceNoNewMoneyDepositHireInformationDepositDropdown = () => (dispatch, getState) => {
    refreshMainNoNewMoneyDepositHireInformationDepositDropdown()(dispatch, getState)
};

const registerDocumentsRequest = (dispatch, data, getState) => {
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
    const controlDigit = data.contratoDeposito.digitodecontrol
    const contract = data.contratoDeposito.numerodecuenta

    const registerDocumentsData =  {
        query: {
            processes: [
                {
                    processRelation: "PRECONTRACTUAL",
                    operationProcessId: preContractualOperationProcessId
                },
                {
                    processRelation: "CONTRACTUAL",
                    operationProcessId: operationProcessId
                }
            ],
            productAlias: DEPOSIT_PRODUCT_ALIAS,
            contract,
            controlDigit,
        }
    }

    dispatch(registerDocuments(registerDocumentsData));
}

const setMainNoNewMoneyDepositMonths = (dispatch, data, getState) => {
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    const immContracts = getState().contracts;
    const productInfo = immContracts.get('deposit_product');
    const productName = `${formatText(productInfo.get('context') + '-' + productInfo.get('name'))}` || '';
    const requestData = {
        header: {
            version: 2
        },
        query: {...data, operationProcessId, productName}
    };
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    return APIPost(dispatch, apiURLBuilder.getURL('hireDepositConfirmation'), requestData)
        .then(response => {
            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));
            registerDocumentsRequest(dispatch, response, getState)
        })
        .catch(response => {
            dispatch(hireContractFailure(response));
        });
};

const hireMainNoNewMoneyDepositMonths = params => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const data = Object.assign(params, { dataToken });
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setMainNoNewMoneyDepositMonths(dispatch, data, getState))
            .catch(response => {
                if(!!response.error) {
                    setMainNoNewMoneyDepositMonths(dispatch, data, getState);
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireMainNoNewMoneyDepositMonths,
    refreshMainNoNewMoneyDepositHireInformation,
    refreshMainBonifiedNoNewMoneyDepositHireInformation,
    refreshMainNoNewMoneyDepositHireInformationDepositDropdown,
    refreshMainBalanceNoNewMoneyDepositHireInformationDepositDropdown,
    requestMainNoNewMoneyDepositHireInformation,
};
